import {extract} from './utils.js';
import {hashCode} from 'utils/hashCode.js';

let lazyCounter=0;
/**
 * Lazily executes the given function only if the args 
 * were different
 * However, it will always extract uniforms as they may be changing
 * even when the code stays static
 */
export const lazy = (fn, ...args) => {
    let lazyReturn = undefined;
    let lazyArgs = undefined;
    let lazyMsg = undefined;
    let extracter = extractUniforms();;
    let _uniforms = undefined;
    let _variables = undefined;
    return ([x]) => {
        let uniforms = extracter(x, ...args);
        let variables = extractVariables(x, ...args);
        let functions = extractFunctions(x, ...args);
        let closure = extractClosure(x, ...args);

        let _args = args.map(x=>x());
        if (objEq(lazyMsg, x) && arrEq(lazyArgs, _args) && uniformsEq(uniforms, _uniforms) &&
            variablesEq(variables, _variables)) {
            lazyReturn.uniforms = uniforms;
            lazyReturn.variables = variables;
            lazyReturn.functions = functions;
            lazyReturn.closure = closure;
            lazyArgs = _args;
            lazyMsg = x;
            return lazyReturn;
        } else {
            _uniforms = Object.keys(uniforms);
            _variables = {... variables};
            let code = fn(x);
            lazyArgs = _args;
            lazyMsg = x;
            lazyReturn = {
                code,
                hashCode: hashCode(code),
                uniforms,
                variables,
                functions,
                closure: closure
            };
            return lazyReturn;
        }
    };
};

export const extractUniforms = () => {
    let uniforms = {};
    return (...args) => {
        let codes = [];
        //let uniforms = undefined;
        
        for (let arg of args) {
            if (typeof arg === "function") {
                arg = arg();
            }
            if (arg && arg.uniforms) {
                for (let a in arg.uniforms) {
                    uniforms[a] = arg.uniforms[a];
                }
            }
        }
        
        return uniforms;
    };
};

export const extractVariables = (...args) => {
    let variables = {};
    //let uniforms = undefined;
    
    for (let arg of args) {
        if (typeof arg === "function") {
            arg = arg();
        }
        if (arg && arg.variables) {
            for (let a in arg.variables) {
                variables[a] = arg.variables[a];
            }
        }
    }
    
    return variables;
};

export const extractClosure = (...args) => {
    let variables = {};
    //let uniforms = undefined;
    
    for (let arg of args) {
        if (typeof arg === "function") {
            arg = arg();
        }
        if (arg && arg.closure) {
            for (let a in arg.closure) {
                variables[a] = arg.closure[a];
            }
        }
    }
    
    return variables;
}

export const extractFunctions = (...args) => {
    let functions = {};
    for (let arg of args) {
        if (typeof arg === "function") {
            arg = arg();
        }
        if (arg && arg.functions) {
            for (let a in arg.functions) {
                functions[a] = arg.functions[a];
            }
        }
    }
    
    return functions;
};



const objEq = (a,b) => {
    if (Array.isArray(a)) {
        return arrEq(a,b);
    }
    if (!a) {
        return !a && !b;
    }
    if (!b) {
        return !a && !b;
    }
    if (a.hashCode && b.hashCode) {
        return a.hashCode === b.hashCode;
    }
    return a===b;
};

// returns true if elements are equal
const arrEq = (a,b) => {
    if (!a) {
        return !a && !b;
    }
    for (let i=0; i < a.length; i++) {
        let _a = a[i];
        let _b = b[i];
        if (_a === undefined || _b === undefined) {
            if (_a === undefined && _b === undefined) {
                continue;
            } else {
                return false;
            }
        }
        if (!((_a.hashCode && (_b.hashCode === _a.hashCode)) ||
              _a === _b)) {
            return false;
        }  
    }
    return true;
};

const uniformsEq = (u1, u2) => {
    let i=0;
    if (Object.keys(u1).length !== Object.keys(u2).length) {
        return false;
    }
    for (let key in u1) {
        if (!u1[key].update || (u2[key] && !u2[key].update)) {
            return false;
        }
        if (u2[i] !== key) {
            return false;
        }
        i++;
    }
    return true;
};

const variablesEq = (v1, v2) => {
    if (!v2) {
        return false;
    }
    for (let key in v1) {
        if (v1[key] !== v2[key]) {
            return false;
        }
    }
    return true;
};
